import { SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import {
  renderCancelUpdateModalButton,
  renderUpdateProfileModalButton,
} from './APGLUserProfileUtils';

interface Props {
  isUpdatingProfile: boolean;
  isUpdateEnabled: boolean;
  handleUpdate: () => Promise<void>;
  handleCancel: () => void;
}

const APGLUserProfileEditingControls: React.FunctionComponent<Props> = ({
  isUpdatingProfile,
  isUpdateEnabled,
  handleUpdate,
  handleCancel,
}: Props) => {
  const cancelButton = renderCancelUpdateModalButton('link', handleCancel);
  const confirmButton = renderUpdateProfileModalButton(
    handleUpdate,
    isUpdatingProfile,
    isUpdateEnabled,
  );
  return (
    <SpaceBetween direction="horizontal" size="s">
      {cancelButton}
      {confirmButton}
    </SpaceBetween>
  );
};

export default APGLUserProfileEditingControls;
